import { createContext } from 'react';
import { StoreApi } from 'zustand';

import { MapContextState } from '@/types/MapContextState';

export const MapContext = createContext<StoreApi<MapContextState> | null>(null);
